import { HouseholdItem, PEOPLE, Person } from './types';
import { isOverdue } from './householdUtils';

interface UpcomingUnassignedProps {
  items: HouseholdItem[];
  projectColors: Record<string, string>;
  // eslint-disable-next-line no-unused-vars
  onAssign: (id: string, assignee: Person) => void;
  // eslint-disable-next-line no-unused-vars
  onEdit: (item: HouseholdItem) => void;
}

function UpcomingUnassigned({
  items, projectColors, onAssign, onEdit,
}: UpcomingUnassignedProps) {
  const openItems = items.filter((i) => i.status !== 'done');
  const unassigned = openItems
    .filter((i) => !i.assignee)
    .sort((a, b) => (a.dueDate ?? '9999').localeCompare(b.dueDate ?? '9999'));
  const upcomingAssigned = openItems
    .filter((i) => i.assignee && i.dueDate)
    .sort((a, b) => (a.dueDate ?? '').localeCompare(b.dueDate ?? ''))
    .slice(0, 10);

  const dot = (item: HouseholdItem) => (
    item.projectId && projectColors[item.projectId] ? (
      <span
        className="hh-color-dot"
        style={{ backgroundColor: projectColors[item.projectId] }}
      />
    ) : null
  );

  return (
    <div className="hh-upcoming">
      <section>
        <h2>
          Unassigned (
          {unassigned.length}
          )
        </h2>
        {unassigned.length === 0 && <p className="hh-empty">Everything&apos;s assigned. Nice.</p>}
        <ul className="hh-list">
          {unassigned.map((item) => (
            <li key={item.id} className={isOverdue(item) ? 'hh-list-overdue' : ''}>
              {dot(item)}
              <button type="button" className="hh-list-title" onClick={() => onEdit(item)}>
                {item.title}
              </button>
              <span className="hh-list-due">
                {item.dueDate ? `Due ${item.dueDate}` : 'No due date'}
              </span>
              <span className="hh-list-assign">
                {PEOPLE.map((p) => (
                  <button
                    key={p}
                    type="button"
                    className="hh-btn hh-btn-small hh-btn-secondary"
                    onClick={() => onAssign(item.id, p)}
                  >
                    {p}
                  </button>
                ))}
              </span>
            </li>
          ))}
        </ul>
      </section>

      <section>
        <h2>Upcoming (assigned)</h2>
        {upcomingAssigned.length === 0 && <p className="hh-empty">Nothing on the radar.</p>}
        <ul className="hh-list">
          {upcomingAssigned.map((item) => (
            <li key={item.id} className={isOverdue(item) ? 'hh-list-overdue' : ''}>
              {dot(item)}
              <button type="button" className="hh-list-title" onClick={() => onEdit(item)}>
                {item.title}
              </button>
              <span className="hh-list-due">
                Due
                {' '}
                {item.dueDate}
              </span>
              <span className="hh-list-assign">{item.assignee}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default UpcomingUnassigned;
